import { z } from 'zod'
import { Temporal } from '@js-temporal/polyfill'
import { AppKind } from '../../models/App'
import type { AppCredentials } from '../../models/AppCredentials'
import { createPlainDateFromString } from '~/shared/composables/useTemporal'

export const AppCredentialsDTO = z.object({
  login_code: z.number(),
  pin: z.object({
    pin: z.number(),
    expirated_at: z.string().datetime()
  }),
  app: z.object({
    id: z.number().optional(),
    name: z.string(),
    type: z.nativeEnum(AppKind),
    key: z.string()
  }),
  updated_at: z.string().datetime()
})

export type AppCredentialsDTO = z.infer<typeof AppCredentialsDTO>

export function mapDTOToAppCredentials (dto: AppCredentialsDTO): AppCredentials {
  return {
    loginCode: dto.login_code,
    pin: {
      pin: dto.pin.pin,
      expiredAt: Temporal.PlainDateTime.from(dto.pin.expirated_at)
    },
    app: {
      id: dto.app.id,
      name: dto.app.name,
      kind: dto.app.type,
      key: dto.app.key
    },
    updatedAt: createPlainDateFromString(dto.updated_at)
  }
}

export function mapAppCredentialsToDTO (model: AppCredentials): AppCredentialsDTO {
  return {
    login_code: model.loginCode,
    pin: {
      pin: model.pin.pin,
      expirated_at: model.pin.expiredAt.toString()
    },
    app: {
      id: model.app.id,
      name: model.app.name,
      type: model.app.kind,
      key: model.app.key
    },
    updated_at: model.updatedAt.toString()
  }
}
